import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { CompassRights } from 'Images';

interface ITitle {
  title?: string;
}

export const Title = ({ title }: ITitle) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap={'24px'}
      flexDirection={'row'}
      marginBottom={'8px'}
      width={'fit-content'}
    >
      {isDesktop && (
        <Avatar
          sx={{ width: '48px', height: '48px' }}
          alt=''
          src={CompassRights}
        />
      )}
      <Typography
        variant={'h2'}
        color={'text.secondary'}
        maxWidth='600px'
        whiteSpace={isDesktop ? 'normal' : 'break-spaces'}
        component='h1'
      >
        {title
          ? title
          : Dictionary[DICTIONARY.CompassRights].compassRightsHeader.title}
      </Typography>
    </Stack>
  );
};
